import { ComponentType } from 'react';
import { withTranslation } from '@wix/yoshi-flow-editor';

export type { TFunction } from '@wix/yoshi-flow-editor';

export default (Component: ComponentType) => withTranslation()(Component);
